



































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    Modal,
    Button,
  },
})
export default class ModalDialog extends Vue {
  @Prop({ default: false }) readonly value!: boolean;
  @Prop({ default: '' }) readonly title!: string;
  @Prop({ default: '' }) readonly text!: string;
  @Prop({ default: false }) readonly center!: boolean;
  @Prop({ default: false }) readonly withBody!: boolean;
  @Prop({ default: true }) readonly showYes!: boolean;
  @Prop({ default: true }) readonly showNo!: boolean;
  @Prop({ default: 'Yes' }) readonly yesText!: string;
  @Prop({ default: 'No' }) readonly noText!: string;
  @Prop({ default: 'dialog' }) readonly target!: string;

  handleClickNo() {
    this.$emit('input', false);
    this.$emit('noClicked');
  }

  handleClickYes() {
    this.$emit('input', false);
    this.$emit('yesClicked');
  }
}
